import { Select } from "@mantine/core";
import { useTranslation } from "react-i18next";

import type { WeeklyLead } from "@msc/shared";

/** Ein Eintrag je Lead × Segment; Wert „employeeId|segmentId". */
export function LeadPicker({
  leads,
  value,
  onChange,
}: {
  leads: WeeklyLead[];
  value: { employeeId: string; segmentId: string } | null;
  onChange: (v: { employeeId: string; segmentId: string }) => void;
}) {
  const { t } = useTranslation();
  const data = leads.map((l) => ({
    value: `${l.employeeId}|${l.segmentId}`,
    label: `${l.fullName} · ${l.segmentName}`,
  }));
  return (
    <Select
      label={t("weekly.pickLead")}
      data={data}
      searchable
      value={value ? `${value.employeeId}|${value.segmentId}` : null}
      onChange={(v) => {
        if (!v) return;
        const [employeeId, segmentId] = v.split("|") as [string, string];
        onChange({ employeeId, segmentId });
      }}
      w={360}
    />
  );
}
